module.exports = __webpack_public_path__ + "img/whitelogo.dca62aab.png";